import { IRowAction } from "../../../../../Component/Common/Components/DataTable/RowAction";
import { AttendeeDto } from "../../../../../Component/Model/Dto/WSP/Attendees/MerSETAAttendees";
import { TableColumn } from "../../../../../Component/Model/Table/Table";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { id } from "date-fns/locale";
import { actions } from "react-table";
import { VaMethodology } from "../../../../../Component/Model/Dto/VerificationAgency/VaMethodology";
import tooltip from "../../../../../assets/theme/components/tooltip";
import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { result } from "lodash";
import { JobTitles } from "../../../../../Component/Api/OFOCodes/ApiUrl.OfoCode";



interface AncillaryCostAttendeeTableRow {
    attendee: String,
    idNumber: String,
    employeeCode: String,
    jobTitle: String,
    actions?: IRowAction[];
}

export interface IAncillaryCostAttendeeTable {
    columns: Array<TableColumn>;
    rows: Array<AncillaryCostAttendeeTableRow>;
}

export function AncillaryCostAttendeeTableMapper(results: AttendeeDto[], showDeleteAttendeeConfirmation: (id: string, name: string) => void) : IAncillaryCostAttendeeTable 
{
    const columns: TableColumn[] = [
        { Header: 'Attendee', accessor: 'attendee', id: 'attendee', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'ID Number', accessor: 'idNumber', id: 'idNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Employee Code', accessor: 'employeeCode', id: 'employeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Job Title', accessor: 'jobTitle', id: 'jobTitle', Cell: ({ value }: any) => <DefaultCell value={value}  />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];


    if (results != undefined && results.length > 0) {
        const rows: AncillaryCostAttendeeTableRow[] = results.map((item: AttendeeDto, index: number) => ({
            attendee : item.attendee,
            idNumber : item.idNumber,
            employeeCode : item.employeeCode,
            jobTitle : item.jobTitle,
            actions: [
                {
                    type: 'Delete',
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        showDeleteAttendeeConfirmation(item.platformPeopleId, item.attendee);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}